
import { MOVEMENT_TYPES } from "../constants/index";
import { ENTITY } from "constants/entities";
import { Article, BumpPolicy, Movement } from "types";

export function bumpArticleAmountsFromMovements(
  prepared: Movement[],
  articlesPool: Article[],
  addSessionData: (entity: string, payload: any) => void,
  policy: BumpPolicy = {}
): void {
  const {
    onPreparation = "none",
    customSignByType,
    clampNonNegative = true,
  } = policy;

  const defaultSign = (movementTypeId: number): 1 | -1 | 0 => {
    const custom = customSignByType?.[movementTypeId];
    if (custom !== undefined) return custom;
    if (movementTypeId === MOVEMENT_TYPES.INCOME.id) return 1;
    if (movementTypeId === MOVEMENT_TYPES.DISCHARGE.id) return -1;
    if (movementTypeId === MOVEMENT_TYPES.PREPARATION.id) {
      return onPreparation === "add" ? 1 : onPreparation === "subtract" ? -1 : 0;
    }
    return 0;
  };

  const deltaByArticle = new Map<number, number>();

  for (let i = 0; i < prepared.length; i++) {
    const mov = prepared[i];
    const sign = defaultSign(mov.movement_type_id);
    if (sign === 0) continue;

    const rows = mov.articles || [];
    for (let j = 0; j < rows.length; j++) {
      const ma = rows[j];
      const qty = Number(ma.amount ?? ma.article_locations?.stock ?? 0);
      if (!qty) continue;

      const artId = ma.article_id ?? ma.article_locations?.article_id;
      if (!artId) continue;

      const prev = deltaByArticle.get(artId) ?? 0;
      deltaByArticle.set(artId, prev + sign * qty);
    }
  }

  deltaByArticle.forEach((delta, articleId) => {
    if (!delta) return;
    const base = articlesPool.find((a) => a.id === articleId);
    const current = base ?? ({ id: articleId, amount: 0 } as Article);
    let nextAmount = Number(current.amount ?? 0) + delta;
    if (clampNonNegative && nextAmount < 0) nextAmount = 0;

    addSessionData(ENTITY.ARTICLES, { ...current, amount: nextAmount });
  });
}